export const environment = {
  production: false,
  API_BASE_PATH: 'https://dev-private-api.dreampay.com.br',
  apiKey: '8edVQyVI35xjmKB4DVIhdiEAW0LTLRLY',
  SENTRY_DSN: '',
  // V2 Logging configuration
  logging: {
    enableV2Logging: true,
    source: 'admin-app',
    bufferSize: 25,
    flushIntervalMs: 5000,
  },
};
